import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Collapse,
  CardContent,
  Menu,
  MenuItem,
} from '@mui/material';
import logoTeleConnx from '../../Logo.png';
import logoDeepgram from '../../Logo2.png';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import MenuIcon from '@mui/icons-material/Menu';
import { grey } from '@mui/material/colors';
import { useLocation } from 'react-router-dom';

export default function NavBar() {
  const pages = ['Home', 'Manual', 'Contact Us', 'Get Started'];
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  return (
    <Box>
      <AppBar
        position='fixed'
        color='inherit'
        elevation={useScrollTrigger() ? 4 : 0}
        sx={{
          minHeight: '106px',
          height: 'auto',
          display: 'flex',
          justifyContent: 'center',
          px: { xs: 4, sm: 12, md: 18, lg: 24, xl: 37.56 },
        }}
      >
        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              mr: 2,
              ml: '11px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={logoTeleConnx}
              srcSet={logoTeleConnx}
              alt={'logoTeleConnx'}
              loading='lazy'
              height='40px'
              onClick={() => {
                document.location.href = 'https://teleconnx.com/dg-stt/';
              }}
            />
          </Box>
          <Box
            sx={{
              mr: '10px',
              ml: '9px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              src={logoDeepgram}
              srcSet={logoDeepgram}
              alt={'logoDeepgram'}
              loading='lazy'
              height='30px'
              onClick={() => {
                document.location.href = 'https://teleconnx.com/dg-stt/';
              }}
            />
          </Box>
          <Box
            sx={{
              flexGrow: 10,
              alignItems: 'center',
              display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' },
            }}
          >
            <Box sx={{ flexGrow: 3, display: 'flex' }} />
            <Box
              sx={{
                flexGrow: 2,
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                fontSize: '16px',
                fontFamily:
                  'system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              }}
            >
              <Typography
                component='div'
                sx={{
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  color: '#252525',
                  opacity: 0.8,
                  cursor: 'pointer',
                }}
              >
                <a
                  href='https://www.teleconnx.com/dg-stt/'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Home
                </a>
              </Typography>
              <Typography
                component='div'
                sx={{
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  color: '#252525',
                  opacity: 0.8,
                  cursor: 'pointer',
                }}
              >
                <a
                  href='https://www.teleconnx.com/docs/'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Manual
                </a>
              </Typography>
              <Typography
                component='div'
                sx={{
                  fontWeight: 600,
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  color: '#252525',
                  opacity: 0.8,
                  cursor: 'pointer',
                }}
              >
                <a
                  href='https://www.teleconnx.com/dg-stt/contact-us.html'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Contact Us
                </a>
              </Typography>
            </Box>
            <Box sx={{ flexGrow: 3, display: 'flex' }} />
          </Box>

          <Button
            sx={{
              flexGrow: 1,
              fontFamily: 'inherit',
              fontSize: 'inherit',
              textTransform: 'uppercase',
              fontWeight: 700,
              borderRadius: '8px',
              display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' },
              padding: '10px 0px',
              background: 'linear-gradient(180deg, #0196FF 0%, #006BB6 100%)',
            }}
            variant='contained'
            onClick={() => {
              document.location.href =
                'https://teleconnx.com/dg-stt/get-started.html';
            }}
          >
            get started
          </Button>
          <Box
            sx={{
              flexGrow: 1,
              justifyContent: 'end',
              display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none' },
            }}
          >
            <IconButton onClick={handleOpenNavMenu}>
              <MenuIcon
                sx={{
                  fontSize: '32px',
                }}
              />
            </IconButton>
            <Menu
              sx={{ mt: '45px' }}
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
            >
              {pages.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseNavMenu}>
                  <Typography textAlign='center'>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>
      </AppBar>
    </Box>
  );
}

// import * as React from 'react';
// import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
// import Menu from '@mui/material/Menu';
// import MenuIcon from '@mui/icons-material/Menu';
// import Container from '@mui/material/Container';
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
// import MenuItem from '@mui/material/MenuItem';
// import AdbIcon from '@mui/icons-material/Adb';

// const pages = ['Products', 'Pricing', 'Blog'];
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

// function NavBar() {
//   const [anchorElNav, setAnchorElNav] = React.useState(null);
//   const [anchorElUser, setAnchorElUser] = React.useState(null);

//   const handleOpenNavMenu = (event) => {
//     setAnchorElNav(event.currentTarget);
//   };
//   const handleOpenUserMenu = (event) => {
//     setAnchorElUser(event.currentTarget);
//   };

//   const handleCloseNavMenu = () => {
//     setAnchorElNav(null);
//   };

//   const handleCloseUserMenu = () => {
//     setAnchorElUser(null);
//   };

//   return (
//     <AppBar position='static'>
//       <Container maxWidth='xl'>
//         <Toolbar disableGutters>
//           <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
//           <Typography
//             variant='h6'
//             noWrap
//             component='a'
//             href='/'
//             sx={{
//               mr: 2,
//               display: { xs: 'none', md: 'flex' },
//               fontFamily: 'monospace',
//               fontWeight: 700,
//               letterSpacing: '.3rem',
//               color: 'inherit',
//               textDecoration: 'none',
//             }}
//           >
//             LOGO
//           </Typography>

//           <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
//             <IconButton
//               size='large'
//               aria-label='account of current user'
//               aria-controls='menu-appbar'
//               aria-haspopup='true'
//               onClick={handleOpenNavMenu}
//               color='inherit'
//             >
//               <MenuIcon />
//             </IconButton>
//             <Menu
//               id='menu-appbar'
//               anchorEl={anchorElNav}
//               anchorOrigin={{
//                 vertical: 'bottom',
//                 horizontal: 'left',
//               }}
//               keepMounted
//               transformOrigin={{
//                 vertical: 'top',
//                 horizontal: 'left',
//               }}
//               open={Boolean(anchorElNav)}
//               onClose={handleCloseNavMenu}
//               sx={{
//                 display: { xs: 'block', md: 'none' },
//               }}
//             >
//               {pages.map((page) => (
//                 <MenuItem key={page} onClick={handleCloseNavMenu}>
//                   <Typography textAlign='center'>{page}</Typography>
//                 </MenuItem>
//               ))}
//             </Menu>
//           </Box>
//           <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
//           <Typography
//             variant='h5'
//             noWrap
//             component='a'
//             href=''
//             sx={{
//               mr: 2,
//               display: { xs: 'flex', md: 'none' },
//               flexGrow: 1,
//               fontFamily: 'monospace',
//               fontWeight: 700,
//               letterSpacing: '.3rem',
//               color: 'inherit',
//               textDecoration: 'none',
//             }}
//           >
//             LOGO
//           </Typography>
//           <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
//             {pages.map((page) => (
//               <Button
//                 key={page}
//                 onClick={handleCloseNavMenu}
//                 sx={{ my: 2, color: 'white', display: 'block' }}
//               >
//                 {page}
//               </Button>
//             ))}
//           </Box>

//           <Box sx={{ flexGrow: 0 }}>
//             <Tooltip title='Open settings'>
//               <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
//                 <Avatar alt='Remy Sharp' src='/static/images/avatar/2.jpg' />
//               </IconButton>
//             </Tooltip>
//             <Menu
//               sx={{ mt: '45px' }}
//               id='menu-appbar'
//               anchorEl={anchorElUser}
//               anchorOrigin={{
//                 vertical: 'top',
//                 horizontal: 'right',
//               }}
//               keepMounted
//               transformOrigin={{
//                 vertical: 'top',
//                 horizontal: 'right',
//               }}
//               open={Boolean(anchorElUser)}
//               onClose={handleCloseUserMenu}
//             >
//               {settings.map((setting) => (
//                 <MenuItem key={setting} onClick={handleCloseUserMenu}>
//                   <Typography textAlign='center'>{setting}</Typography>
//                 </MenuItem>
//               ))}
//             </Menu>
//           </Box>
//         </Toolbar>
//       </Container>
//     </AppBar>
//   );
// }
// export default NavBar;
